// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ErrorInformationStorage } from '@shared/commons/ErrorInformationStorage';
import { BaseItem, ColumnData } from './BaseItem';
import { ColumnParams } from './ColumnParams';
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { TableTotalsVisibility } from './TableTotalsVisibility';
import { QTAlignment } from '../elements/QuickTable/QuickTableColumn';
export class FullLogsItem extends BaseItem {
    constructor(info) {
        super(null);
        FullLogsItem.StaticID++;
        this.itemId = FullLogsItem.StaticID;
        this.info = info;
    }
    ColumnCount() {
        return FullLogsItem.columnsParams.length;
    }
    GetColumnParams(column) {
        const result = FullLogsItem.columnsParams[column];
        result.Hidden = result.DefaultHidden;
        return result;
    }
    getColumnData(column) {
        let o = '';
        try {
            o = this.getColumnValue(column);
        }
        catch (ex) {
            ErrorInformationStorage.GetException(ex);
        }
        const FormattedValue = o !== null && o !== undefined ? o.toString() : '';
        return new ColumnData(o, FormattedValue);
    }
    getColumnValue(column) {
        try {
            if (this.info == null) {
                return '';
            }
            switch (column) {
                case 0:
                    // if (BaseApplication.App.Settings != null && BaseApplication.App.MultiDataCache.DCache != null)
                    //    return BaseApplication.App.Settings.ConvertUTCTimeToSelectedTimeZone(info.dateTime, BaseApplication.App.MultiDataCache.DCache).toString("HH:mm:ss.fff");
                    // else
                    return DateTimeUtils.formatDate(this.info.dateTime, 'HH:mm:ss:SSS');
                // return info.dateTime.toString("HH:mm:ss.fff");
                case 1:
                    return this.info.MessageName + ' (' + this.info.MessageCode + ')';
                case 2:
                    return this.info.Text;
                case 3:
                    return this.info.NodeAddress;
                case 4:
                    return this.info.Session;
                case 5:
                    return this.info.Side;
                case 6:
                    return this.info.TextNew;
                case 7:
                    return this.info.StringMode;
                default:
                    return '';
            }
        }
        catch (ex) {
            ErrorInformationStorage.GetException(ex);
            return '';
        }
    }
}
FullLogsItem.StaticID = 0;
FullLogsItem.columnsParams = [
    new ColumnParams('FullLogs.DateTime', 15, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('FullLogs.Message name', 60, QTAlignment.Left, TableTotalsVisibility.None, true, true),
    new ColumnParams('FullLogs.Fields', 80, QTAlignment.Left, TableTotalsVisibility.None, true, true),
    new ColumnParams('FullLogs.Cluster', 20, QTAlignment.Left, TableTotalsVisibility.None, false, true),
    new ColumnParams('FullLogs.Session', 20, QTAlignment.Left, TableTotalsVisibility.None, false, true),
    new ColumnParams('Direction', 20, QTAlignment.Left, TableTotalsVisibility.None, false, true),
    new ColumnParams('FullLogs.FieldsNew', 80, QTAlignment.Left, TableTotalsVisibility.None, false, true),
    new ColumnParams('FullLogs.Mode', 80, QTAlignment.Left, TableTotalsVisibility.None, false, true)
];
